import React from 'react';
import { Box, IconButton, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { useTheme } from '@emotion/react';
import { Icon } from '@iconify/react/dist/iconify.js';

const menuItems = [
  { label: 'Dashboard', icon: <Icon icon="material-symbols-light:dashboard" style={{fontSize:'40px'}}/>, route: '/manager/dashboard' },
  { label: 'Expense Management', icon: <Icon icon="fluent:money-24-filled" style={{fontSize:'40px'}}/>, route: '/manager/expense-management' },
  { label: 'Delivery Challan Management', icon: <Icon icon="fluent:receipt-16-filled" style={{fontSize:'40px'}}/>, route: '/manager/delivery-challan-management' },
  { label: 'Material Management', icon: <Icon icon="lets-icons:materials-light" style={{fontSize:'40px'}}/>, route: '/manager/material-management' },
  { label: 'Vehicle Management', icon: <Icon icon="nimbus:truck" style={{fontSize:'40px'}}/>, route: '/manager/vehicle-management' },
  { label: 'Quality Control Checklist', icon: <Icon icon="carbon:summary-kpi" style={{fontSize:'40px'}}/>, route: '/manager/quality-control-checklist' },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation(); 
  const theme = useTheme()

  return (
    <Box
      sx={{        
        display:"flex",
        flexDirection:"column",
        justifyContent:"center",
        alignItems:"center",
        color: '#fff',
        minHeight: '100vh',
        padding: 2,
      }}
    >
      <List>
        {menuItems.map((item, index) => {
          const isSelected = location.pathname === item.route;

          return(
          <ListItem            
            disablePadding
            dense
            disableGutters  
            key={index}
            onClick={() => navigate(item.route)}  
            sx={{padding:2}}
          >           
            <IconButton disableRipple sx={{color: isSelected ? theme.palette.primary.main : theme.palette.common.white,}}>
              {item.icon}                      
            </IconButton>
              
          </ListItem>
          )
        })}
      </List>
    </Box>
  );
};

export default Sidebar;
